import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary:   '#053cdf',
        secondary: '#b0bec5',
        accent:    '#8c9eff',
        error:     '#b71c1c',

        // WCAG AA-compliant overrides (contrast >= 4.5:1 on white)
        red:    '#c62828',   // was #f44336 (3.68:1) -> 5.94:1
        green:  '#2e7d32',   // was #4caf50 (2.77:1) -> 5.39:1
        blue:   '#1565c0',   // was #2196f3 (3.12:1) -> 6.36:1
        orange: '#bf360a',   // was #ff9800 (2.15:1) -> 4.52:1
      },
    },
  },
});